<div class="container-fluid">
    <div class="row">
        <div class="col-xl-5" [ngStyle]="{'background-image': 'url(assets/images/login/portada_login.png)',
                                        'background-size': 'cover',
                                        'background-position': 'center center',
                                        'display': 'block'}">
            <img class="bg-img-cover bg-center d-none" src="assets/images/login/portada_login.png" alt="looginpage">
        </div>
        <div class="col-xl-7 p-0">
            <div class="login-card">
                <div>
                    <div>
                        <a class="logo" routerLink='/login'>
                            <img class="img-fluid for-light" src="assets/images/login/logo.png" width="200"
                                alt="looginpage">
                            <img class="img-fluid for-dark" src="assets/images/login/logo.png" width="200"
                                alt="looginpage">
                        </a>
                    </div>
                    <div *ngIf="!message">
                        <div class="login-main" *ngFor="let turno of infoTurno">
                            <form class="theme-form needs-validation">
                                <h4 style="color: #334C77;">HOLA {{ turno.paciente }}</h4>
                                <div class="form-group">
                                    <label class="col-form-label">Recordatorio de turno</label><br>
                                    <label class="col-form-label">Con el profesional {{ turno.profesional }}</label><br>
                                    <!-- <label class="col-form-label">de la especialidad {{ turno.especialidad
                                        }}</label><br> -->
                                    <label class="col-form-label">El día {{ turno.fecha }}</label><br>
                                    <label class="col-form-label">A las {{ turno.hora }} hs.</label>
                                </div>
                                <div class="form-group mb-0">
                                    <button class="btn btn-primary btn-pill d-block w-100 mb-2" type="button"
                                        (click)="confirmarTurno(turno.numero)">Confirmar
                                        turno</button>
                                    <button class="btn btn-secondary btn-pill d-block w-100" type="button"
                                        (click)="cancelarTurno(turno.numero)">Cancelar
                                        turno</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div *ngIf="message" class="text-center" style="color: #334C77;">
                        <h3>{{messageWhatsapp}}</h3>
                        <h4>Para sacar otro turno, ingresá a nuestro turnero.</h4>                        
                        <a style="font-size: 25px; text-decoration: none; color: #334C77; font-weight: bold;" routerLink='/login'>👉👉 Turnos Online 👈👈</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>